/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-29 14:50:19
 * @LastEditors: 
 * @LastEditTime: 2020-09-29 14:51:26
 */
import SelectQuery from './selectQuery';

export default SelectQuery